/* Match the existing Shopify percentage product discount's per-unit cent rounding.
 * Scope: YOURS offer 13955, USD, single-section percentage tiers only.
 * Rebolt continues to own product selection, inventory, discounts, and checkout.
 */
(() => {
  const root = document.querySelector('#wine_build_box[data-yours-currency="USD"]');
  if (!root) return;
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const cents = value => {
    const match = value.trim().match(/^\$([\d,]+\.\d{2})$/);
    return match ? Math.round(Number(match[1].replaceAll(',', '')) * 100) : NaN;
  };
  function update() {
    const total = root.querySelector('.th_pb_cb_sidecart_title .th_pb_main_price .money');
    const tier = root.querySelector('.th_round_circle_highlight_wc p');
    const match = tier?.textContent.match(/^(10|15|20)%/);
    const percent = match ? Number(match[1]) : 0;
    const rows = [...root.querySelectorAll('.th_pb_cb_p_grid_column')];
    if (!total || !rows.length) return;
    let amount = 0;
    for (const row of rows) {
      const unit = cents(row.querySelector('.th_pb_cb_p_grid_price .th_pb_main_price .money')?.textContent || '');
      const quantity = Number(row.querySelector('.th_pb_cb_p_grid_add_qty_text em')?.textContent);
      if (!Number.isSafeInteger(unit) || !Number.isSafeInteger(quantity) || quantity < 0) return;
      amount += (unit - Math.floor(unit * percent / 100)) * quantity;
    }
    const value = money.format(amount / 100);
    if (total.textContent !== value) total.textContent = value;
  }
  const observer = new MutationObserver(() => {
    observer.disconnect();
    update();
    observe();
  });
  function observe() { observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] }); }
  update();
  observe();
})();
